import * as ChartHelper from "./ChartHelper.js";
import Chart from 'chart.js';

export default class LineChart {
    chart = null;
    datasets = null;
    labels = null;
    config = null;
    defer = null;

    static initAll() {
        const lineCharts = document.querySelectorAll('.line-chart');

        if (lineCharts.length == 0)
            return;

        lineCharts.forEach((lineChart) => {
            new LineChart(lineChart)
        });
    }

    constructor(lineChartContainer) {
        if(lineChartContainer == null || lineChartContainer == undefined)
            return;

        
        this.datasets = JSON.parse(lineChartContainer.dataset.datasets);
        this.config = JSON.parse(lineChartContainer.dataset.config);
        this.labels = JSON.parse(lineChartContainer.dataset.labels);
        this.defer = JSON.parse(lineChartContainer.dataset.defer);

        this.updateDatasets();
        
        this.chart = new Chart(lineChartContainer.querySelector('canvas'), {
            type: "line",
            data: {
                datasets: this.datasets,
                labels: this.labels
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: window.screen.width > 600,
                    backgroundColor: "#FFF",
                    titleFontSize: 16,
                    titleFontColor: "#003542",
                    bodyFontColor: "#003542",
                    bodyFontSize: 15,
                    displayColors: true,
                    xPadding: 12,
                    yPadding: 12,
                    caretSize: 10,
                    cornerRadius: 0,
                    callbacks: {
                        label: function (tooltipItems, data) {
                            return data.datasets[tooltipItems.datasetIndex].label + ": " + tooltipItems.yLabel;
                        }
                    }
                },
                legend: {
                    align: window.innerWidth < 768 ? 'start' : 'center'
                },
                plugins: {
                    deferred: this.defer ? this.deferConfig : false
                }
            }
        });
        ChartHelper.SetChartConfig(this.chart, this.config);
    }

    updateDatasets() {
        this.datasets.forEach((dataset) => {
			delete dataset.type;
			dataset.fill = false;
			dataset.borderColor = dataset.backgroundColor;
			dataset.pointRadius = 3;
			dataset.pointHitRadius = 20;

			if (dataset.dashed)
				dataset.borderDash = [5, 5];

			dataset.data.forEach((data, index) => {
				dataset.data[index] = Number(data);
			});
		});
    }
}   